import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../../../utils/mapTableRows";
import {
  Button,
  CustomInput,
  CustomSelect,
  FormFieldSet,
  StatusTags,
  TableAdv,
} from "../../../../../../../components";
import { payableOptions } from "../../../../../../../assets/data/projectData";
import { BillType } from "../../../../../../../assets/data/enumData";
import { useDispatch } from "react-redux";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";

const PayClassification = ({ setActiveTab, currentPlacement, editData }) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const [tableData, setTableData] = useState([
    {
      id: 0,
      payClassification: "Standard Time",
      description: "--",
      // isBillable: "",
      billRate: "1.00",
      isPayable: "",
      payRate: "1.00",
      status: "Active",
    },
    // {
    //   id: 1,
    //   payClassification: "Time Off",
    //   description: "--",
    //   isBillable: "",
    //   billRate: "0.00",
    //   isPayable: "",
    //   payRate: "0.00",
    //   status: "Inactive",
    // },
    // {
    //   id: 2,
    //   payClassification: "OT",
    //   description: "--",
    //   isBillable: "",
    //   billRate: "1.00",
    //   isPayable: "",
    //   payRate: "1.00",
    //   status: "Inactive",
    // },
  ]);

  const handleChangeTable = (field, row, value) => {
    console.log("row", row);
    console.log("field", field);
    console.log("value", value);
    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const renderFormField = (key, row) => {
    console.log("key", key);
    console.log("row", row);
    switch (key) {
      // case "isBillable":
      //   return (
      //     <FormFieldSet
      //       type="select"
      //       title=""
      //       size="xs"
      //       placeholder="Select"
      //       value={row?.isBillable}
      //       options={BillType}
      //       onChange={(e) => handleChangeTable("isBillable", row, e)}
      //     />
      //   );
      case "billRate":
        return (
          <CustomInput
            type="text"
            title=""
            size="xs"
            placeholder="Select"
            value={row?.billRate}
            onChange={(e) => handleChangeTable("billRate", row, e)}
          />
        );

      // case "isPayable":
      //   return (
      //     <FormFieldSet
      //       type="select"
      //       title=""
      //       size="xs"
      //       placeholder="Select"
      //       options={payableOptions}
      //       value={row?.isPayable}
      //       onChange={(e) => handleChangeTable("isPayable", row, e)}
      //     />
      //   );
      case "payRate":
        return (
          <CustomInput
            type="text"
            title=""
            size="xs"
            placeholder="Select"
            value={row?.payRate}
            onChange={(e) => handleChangeTable("payRate", row, e)}
          />
        );

      case "status":
        return <StatusTags tag={row.status} />;

      default:
        return row[key] || "--";
    }
  };

  const columns = [
    { key: "payClassification", label: "Pay Classification", sortable: false },
    { key: "description", label: "Description", sortable: false },
    // {
    //   key: "isBillable",
    //   label: "Is Billable",
    //   render: (row) => renderFormField("isBillable", row),
    //   sortable: false,
    // },
    {
      key: "billRate",
      label: "Bill Rate ",
      sortable: false,
      render: (row) => renderFormField("billRate", row),
    },
    // {
    //   key: "isPayable",
    //   label: "Is Payable",
    //   render: (row) => renderFormField("isPayable", row),
    //   sortable: false,
    // },
    {
      key: "payRate",
      label: "Pay Rate ",
      render: (row) => renderFormField("payRate", row),
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => renderFormField("status", row),
      sortable: false,
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  const handleSave = () => {
    const payClassification = tableData.map((data) => ({
      field: data.payClassification,
      description: data.description,
      // billable: data.isBillable? true : false,
      billRate: data.billRate,
      // payable: data.isPayable ? true : false,
      payRate: data.payRate,
      status: data.status === "Inactive" ? 2 : 1,
    }));
    const submissionData = filterEmptyValues(payClassification);
    const uiid = fetchPerticularData?.uiid ?? "";
    dispatch(
      addNewPlacementStart({
        uiid: uiid,
        rsd: submissionData,
        rsn: "clientPlacementTimesheetPayClassification",
        payload: [
          {
            type: "SET",
            value: {
              timesheetDetails: {
                payClassification: {
                  ...submissionData,
                },
              },
            },
          },
        ],
        onSuccess: async (payload) => {
          console.log("payload : ", payload);
          setActiveTab((prev) => prev + 1);
        },
      }),
    );
  };
  useEffect(() => {
    const clientPlacementPayments = currentPlacement?.clientPlacementPayments;
    if (clientPlacementPayments) {
      handleChangeTable(
        "billRate",
        { id: 0 },
        clientPlacementPayments?.billRate?.rate,
      );
      handleChangeTable(
        "payRate",
        { id: 0 },
        clientPlacementPayments?.payRate?.payRatePerHour,
      );
    }
  }, [currentPlacement]);
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "timesheetDetails.payClassification uiid",
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);

          const clientPlacementPayments =
            data?.timesheetDetails?.payClassification?.[0] || {};
          console.log("clientPlacementPayments", clientPlacementPayments);

          if (clientPlacementPayments) {
            const { billRate, payRate } = clientPlacementPayments;

            if (billRate != null && billRate !== "") {
              handleChangeTable("billRate", { id: 0 }, billRate);
            }

            if (payRate != null && payRate !== "") {
              handleChangeTable("payRate", { id: 0 }, payRate);
            }
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[65vh] overflow-auto">
    <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto flex-1">
      <TableAdv
        tableId={`employee_placement_addclientplacement_timesheetdetails_payclassification`}
        rows={mappedRows}
        columns={columns}
        // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        hideToolBar
      />

      <div className="flex gap-3 justify-end mt-6">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default PayClassification;
